import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { endAuthSession, getCurrentUser } from '@/lib/api/auth';
import { trackLogoutCompleted } from '@/lib/analytics/trackers/auth';
import { showSuccessToast } from '@/utils/toast-utils';

export const useAuthState = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Check if user is logged in whenever location changes
  useEffect(() => {
    const checkAuthStatus = () => {
      setIsLoggedIn(Boolean(getCurrentUser()?.token));
    };
    
    checkAuthStatus();
  }, [location]);

  const handleLogout = () => {
    trackLogoutCompleted();
    endAuthSession();
    setIsLoggedIn(false);
    showSuccessToast("Logged out successfully", "You have been logged out of your account.");
    navigate('/');
  };

  // Determine if we're on the landing page
  const isLandingPage = location.pathname === '/';

  return {
    isLoggedIn,
    handleLogout,
    isLandingPage
  };
};
